<template>
  <div class="menu-mobile-bottom">
    <div class="content">
      <BaseButton
        class="button-search"
        icon-left="search/search-normal"
        size="l"
        aria-label="Открыть поиск"
        @click="openMobileSearch"
      />

      <div class="nav-wrapper">
        <ul class="menu-tabs">
          <li class="menu-tab" @click="goToMain">
            <BaseIconSvoi icon="essential/home" size="s" />
            <span class="name">Главная</span>
          </li>
          <li class="menu-tab" @click="openSideMenu">
            <BaseIconSvoi icon="fluent/list-24-filled" size="s" />
            <span class="name">Меню</span>
          </li>

          <li class="menu-tab gap" />

          <li class="menu-tab" @click="goToProfile">
            <BaseIconSvoi icon="users/user" size="s" />
            <span class="name">Профиль</span>
          </li>

          <li class="menu-tab" @click="openEcosystem">
            <BaseIconSvoi icon="fluent/grid-dots-20-filled" size="s" />
            <span class="name">Сервисы</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { BaseButton } from '~/components/base-ui/buttons'
  import { BaseIconSvoi } from '~/components/base-ui/icon'
  import { useGlobalSearch } from '~/composables/global-search/use-global-search'
  import { useAuthModal } from '~/composables/use-auth-modal'
  import { useAuth } from '~/composables/use-auth'

  const emit = defineEmits(['open-side-menu', 'open-ecosystem'])
  const { openMobileSearch } = useGlobalSearch()
  const { openModal } = useAuthModal()
  const { isAuth } = useAuth()

  const router = useRouter()

  const openSideMenu = () => {
    emit('open-side-menu')
  }

  const openEcosystem = () => {
    emit('open-ecosystem')
  }

  const goToMain = () => {
    router.push('/')
  }

  const goToProfile = () => {
    if (!isAuth.value) {
      openModal()
      return
    }

    router.push('/account')
  }
</script>

<style lang="scss" scoped>
  .menu-mobile-bottom {
    z-index: 55;
    position: fixed;
    bottom: 0;
    display: none;
    width: 100%;

    @include vp-767 {
      display: block;
    }

    > .content {
      padding-top: 28px;
      filter: drop-shadow(0 -1px 57px rgb(0 0 0 / 25%));

      > .button-search {
        position: absolute;
        left: 50%;
        bottom: 32px;
        width: 56px;
        height: 56px;
        background-color: $color-kiwi-50;
        transform: translateX(-50%);
      }

      > .nav-wrapper {
        height: 60px;
        padding: 0 16px;
        background-color: $color-default-white;
        clip-path: polygon(
          0 56px,
          0 20px,
          0.1px 17.9px,
          0.4px 16px,
          0.6px 15px,
          0.9px 14px,
          1.3px 12.8px,
          2px 11.3px,
          2.5px 10.3px,
          3.1px 9.3px,
          3.6px 8.6px,
          4.3px 7.6px,
          5.2px 6.6px,
          5.8px 6px,
          6.7px 5px,
          7.8px 4.1px,
          8.7px 3.5px,
          9.4px 3px,
          10.3px 2.5px,
          11.1px 2.1px,
          12px 1.7px,
          13.2px 1.2px,
          14.2px 0.8px,
          15.5px 0.5px,
          17.1px 0.2px,
          18.1px 0.1px,
          18.9px 0,
          21.7px 0,
          calc(50% - 43.8px) 0,
          calc(50% - 42.1px) 0,
          calc(50% - 41.3px) 0.1px,
          calc(50% - 40.2px) 0.4px,
          calc(50% - 39.3px) 0.8px,
          calc(50% - 38.7px) 1.1px,
          calc(50% - 38px) 1.6px,
          calc(50% - 37.3px) 2.1px,
          calc(50% - 36.7px) 2.7px,
          calc(50% - 36.2px) 3.3px,
          calc(50% - 35.7px) 4.1px,
          calc(50% - 35.4px) 4.7px,
          calc(50% - 35.1px) 5.3px,
          calc(50% - 34.9px) 6px,
          calc(50% - 34.7px) 6.6px,
          calc(50% - 34.5px) 8.3px,
          calc(50% - 32.4px) 15.8px,
          calc(50% - 30.5px) 19.5px,
          calc(50% - 28.7px) 22.3px,
          calc(50% - 26.8px) 24.6px,
          calc(50% - 25px) 26.5px,
          calc(50% - 23.1px) 28.2px,
          calc(50% - 21.3px) 29.6px,
          calc(50% - 19.4px) 30.9px,
          calc(50% - 17.6px) 32px,
          calc(50% - 13.9px) 33.7px,
          calc(50% - 12px) 34.4px,
          calc(50% - 10.2px) 34.9px,
          calc(50% - 6.5px) 35.7px,
          calc(50% - 4.6px) 35.9px,
          calc(50% - 2.8px) 36px,
          calc(50% - 0.9px) 36px,
          50% 36px,
          calc(50% + 0.9px) 36px,
          calc(50% + 2.8px) 36px,
          calc(50% + 4.6px) 35.9px,
          calc(50% + 6.5px) 35.7px,
          calc(50% + 8.3px) 35.3px,
          calc(50% + 10.2px) 34.9px,
          calc(50% + 13.9px) 33.7px,
          calc(50% + 15.7px) 32.9px,
          calc(50% + 17.6px) 31.9px,
          calc(50% + 19.4px) 30.9px,
          calc(50% + 21.3px) 29.6px,
          calc(50% + 23.1px) 28.2px,
          calc(50% + 25px) 26.5px,
          calc(50% + 26.8px) 24.5px,
          calc(50% + 28.7px) 22.2px,
          calc(50% + 30.5px) 19.4px,
          calc(50% + 32.4px) 15.8px,
          calc(50% + 34.5px) 8.4px,
          calc(50% + 34.5px) 8px,
          calc(50% + 34.5px) 7.7px,
          calc(50% + 34.6px) 7.2px,
          calc(50% + 34.7px) 6.7px,
          calc(50% + 34.8px) 6.1px,
          calc(50% + 34.9px) 5.7px,
          calc(50% + 35.1px) 5.2px,
          calc(50% + 35.3px) 4.8px,
          calc(50% + 35.6px) 4.1px,
          calc(50% + 36px) 3.6px,
          calc(50% + 36.4px) 3px,
          calc(50% + 36.7px) 2.6px,
          calc(50% + 37.2px) 2.2px,
          calc(50% + 37.7px) 1.8px,
          calc(50% + 38.1px) 1.5px,
          calc(50% + 38.7px) 1.1px,
          calc(50% + 39.3px) 0.8px,
          calc(50% + 39.9px) 0.5px,
          calc(50% + 40.6px) 0.3px,
          calc(50% + 41.3px) 0.1px,
          calc(50% + 42px) 0,
          calc(50% + 42.8px) 0,
          calc(100% - 20px) 0,
          calc(100% - 18.5px) 0.1px,
          calc(100% - 17.7px) 0.1px,
          calc(100% - 17.2px) 0.2px,
          calc(100% - 16.3px) 0.3px,
          calc(100% - 15.1px) 0.6px,
          calc(100% - 13.9px) 0.9px,
          calc(100% - 13.1px) 1.2px,
          calc(100% - 12.4px) 1.5px,
          calc(100% - 11.5px) 1.9px,
          calc(100% - 10.5px) 2.4px,
          calc(100% - 9.7px) 2.8px,
          calc(100% - 9.1px) 3.2px,
          calc(100% - 8.4px) 3.7px,
          calc(100% - 7.4px) 4.4px,
          calc(100% - 6.8px) 5px,
          calc(100% - 6.2px) 5.5px,
          calc(100% - 5.7px) 6px,
          calc(100% - 5px) 6.7px,
          calc(100% - 4.5px) 7.4px,
          calc(100% - 4px) 8px,
          calc(100% - 3.3px) 8.9px,
          calc(100% - 2.7px) 10px,
          calc(100% - 2.3px) 10.7px,
          calc(100% - 2px) 11.3px,
          calc(100% - 1.7px) 11.9px,
          calc(100% - 1.5px) 12.5px,
          calc(100% - 1.2px) 13.1px,
          calc(100% - 1px) 13.8px,
          calc(100% - 0.8px) 14.5px,
          calc(100% - 0.6px) 15.3px,
          calc(100% - 0.4px) 16.2px,
          calc(100% - 0.2px) 17px,
          calc(100% - 0.1px) 17.6px,
          calc(100% - 0.1px) 18.3px,
          100% 19.2px,
          100% 19.8px,
          100% 100%,
          0 100%
        );
      }

      > .nav-wrapper > .menu-tabs {
        @include list-reset;

        display: flex;
        justify-content: space-evenly;
        gap: 16px;
        width: 100%;
        height: 100%;

        > .menu-tab {
          @extend %flex-column;

          justify-content: center;
          align-items: center;
          gap: 4px;

          > .name {
            @extend %font-10;
          }

          &.gap {
            width: 30px;
          }
        }
      }
    }
  }
</style>
